var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 2a2 2 0 0 1 2-2h3.5a.5.5 0 0 1 0 1H3a1 1 0 0 0-1 1 .5.5 0 0 1 0 1v1a.5.5 0 0 1 0 1v1a.5.5 0 0 1 0 1v1a.5.5 0 0 1 0 1 1 1 0 0 0 1 1h5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0A1.5 1.5 0 0 1 8 11H6v1l-1.5-1L3 12v-1a2 2 0 0 1-2-2H.5a.5.5 0 0 1 0-1H1V7H.5a.5.5 0 0 1 0-1H1V5H.5a.5.5 0 0 1 0-1H1V3H.5a.5.5 0 0 1 0-1zm8-1a.5.5 0 0 0-.5.5v1h1v-1A.5.5 0 0 0 9 1m-.5 4V3.5h1V5c0 .394-.166.942-.381 1.42q-.06.133-.119.247a5 5 0 0 1-.119-.247C8.666 5.942 8.5 5.394 8.5 5m-1-3.5a1.5 1.5 0 1 1 3 0V2c.413 0 .783.201 1.041.459S12 3.087 12 3.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 0-.166-.334A.5.5 0 0 0 10.5 3v2c0 .606-.234 1.308-.469 1.83a5 5 0 0 1-.373.695c-.06.09-.126.18-.196.254a1 1 0 0 1-.14.12A.6.6 0 0 1 9 8a.6.6 0 0 1-.322-.101 1 1 0 0 1-.14-.12 2 2 0 0 1-.196-.254 5 5 0 0 1-.373-.695C7.734 6.308 7.5 5.606 7.5 5zm-4 .5a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1zM3 4.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
});
const SvgManualJournalsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgManualJournalsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "15b8770719c1406a6a44da5949002d1d.svg";